import React, { useState, Fragment } from 'react';
import "./App.css";
import fhatuFB from "./assets/fhatuwani-bigguy.gif";
import "./index.css";
import { BsFillSunFill, BsFillMoonStarsFill } from "react-icons/bs";
import Home from "./components/home";
import Contact from "./components/contact";
import About from "./components/about";
import Skills from "./components/skills";
import Portfolio from "./components/portfolio";
import Footer from "./components/footer";

const handleClickScroll = (val) => {
  const element = document.getElementById(val);
 
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};

function App() {
  const bgColor = {
    backgroundColor: `var(--color)`,
  }
  const divLayout = {
    position: 'fixed',
    fontWeight: 900,
    opacity: 0.9,
    zIndex: 100,
  }

  return (
    <>
      <div className={`navbar bg-blue-500`} style={divLayout}>
        <div className="flex-1 bg-blue-300 gap-4" style={bgColor}>
          <a
            className="btn btn-ghost text-white normal-case text-2xl font-bold"
            onClick={() => handleClickScroll("home")}
          >
            Fhatuwani.
          </a>
        </div>
        <div className='flex gap-4'>
          <button className="btn rounded-full" data-set-theme="dark" data-act-class="ACTIVECLASS"><BsFillMoonStarsFill className='w-4 rounded-full' /></button>
          <button className="btn rounded-full" data-set-theme="light" data-act-class="ACTIVECLASS"><BsFillSunFill className='w-4 rounded-full' /></button>
        </div>
        <div className="flex-none">
          <div className="dropdown dropdown-end px-2">
            <label tabIndex="0" className="btn btn-ghost btn-circle avatar">
              <div className="w-10 rounded-full">
                <img src={fhatuFB} />
              </div>
            </label>
            <ul
              tabIndex="0"
              className="menu menu-compact dropdown-content mt-2 p-2 shadow bg-base-100 rounded-box w-52"
            >
              <li>
                <a
                  className="justify-between"
                  onClick={() => handleClickScroll("home")}
                >
                  Home
                  <span className="badge" tabIndex="1">
                    New
                  </span>
                </a>
              </li>
              <li>
                <a onClick={() => handleClickScroll("about")}>About</a>
              </li>
              <li>
                <a onClick={() => handleClickScroll("skills")}>Skills</a>
              </li>
              <li>
                <a onClick={() => handleClickScroll("portfolio")}>Portfolio</a>
              </li>
              <li>
                <a onClick={() => handleClickScroll("contact")}>Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Home id="home" handleClickScroll={handleClickScroll} />
      <About id="about" handleClickScroll={handleClickScroll} />
      <Skills id="skills" handleClickScroll={handleClickScroll} />
      <Portfolio id="portfolio" handleClickScroll={handleClickScroll} />
      <Contact id="contact" />
      <Footer id="footer" />
    </>
  );
}

export default App;
